import styled, { css } from 'styled-components';
import scoreStaticImage from 'images/sports/common/sp_livescore.png';
import React from 'react';

export const TeamName = styled.div`
  width: 21px;
  height: 9px;
  margin-top: 5px;
  background: url(${scoreStaticImage}) no-repeat 0 -90px;
  ${(props) =>
    props.position === 'HOME' &&
    css`
      background-position: 0 -100px;
    `};
`;
export const Table = styled.table`
  width: 100%;
  margin-top: 15px;
  border-collapse: collapse;

  border: 1px solid #d1d1d1;
  & thead th {
    background: #fafafa;
    height: 30px;
    &:not(:last-child) {
      border-right: 1px solid #e9e9e9;
    }
    border-bottom: 1px solid #d1d1d1;
  }

  & tbody th {
    height: 50px;
    border-right: 1px solid #e9e9e9;
    border-bottom: 1px solid #e9e9e9;
    text-align: left;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 10px 0 10px;
    font-weight: bold;
    & span {
      font-size: 20px;
    }
  }

  & tbody td {
    width: 82px;
    position: relative;
    text-align: center;
    &:not(:last-child) {
      border-right: 1px solid #e9e9e9;
    }
    border-bottom: 1px solid #e9e9e9;
  }

  & tfoot th {
    height: 30px;
    border-right: 1px solid #e9e9e9;
    text-align: left;
    text-indent: 10px;
  }

  & tfoot td {
    text-align: center;
    &:not(:last-child) {
      border-right: 1px solid #e9e9e9;
    }
    background: #fafafa;
  }
`;

export const SpecialWrapper = styled.div`
  height: 13px;
  position: absolute;
  width: 98%;
  bottom: 4px;
  left: 2px;
`;

export const SpecialBox = styled.span`
    && {
        bottom: 0;
        display: inline-block;
        font-family: 'Courier New', 'Dotum', monospace;
        width: 12px;
        height: 13px;
        border: 1px solid #ECEFF3;
        font-size: 10px;
        vertical-align: middle;
        color: ${({ $status }) => ($status ? 'white' : 'gray')};
        background-color: ${({ $status }) => {
          const colorMap = {
            letter: 'red',
            number: 'orange',
          };
          return colorMap[$status] || 'white'; // fallback
        }};
    }}
`;

export const Winner = styled.span`
  border-radius: 100%;
  background-color: #3d93cc;
  color: white;
`;
